import { countryName } from '../countries';
import { COORD, useGlobe } from '../globe';
import type { T } from '../i18n';
import { set } from '../state';
import type { AppState } from '../state';
import type { Postcard } from '../types';
import { BackArrow } from './Icons';

/** The confirmation: the world turns, and the card flies off towards its country. */
export function Sent({ s, t }: { s: AppState; t: T }) {
  const globe = useGlobe();
  const card = s.sentCard;
  if (!card) return null;

  const country = card.toCountry || 'ecuador';
  const spot = globe.project(COORD[country] ?? COORD['ecuador']!);

  return (
    <div class="sent" role="dialog" aria-modal="true" aria-label={t('sentTitle')}>
      <img class="sent-grain" src="/assets/paper.jpg" alt="" />

      <div class="sent-globe">
        <svg viewBox="0 0 100 100" aria-hidden="true">
          <circle cx="50" cy="50" r="47" fill="rgba(247,240,225,.05)" stroke="rgba(247,240,225,.28)" stroke-width=".6" />
          <circle cx="50" cy="50" r="31" fill="none" stroke="rgba(247,240,225,.16)" stroke-width=".5" />
          <circle cx="50" cy="50" r="15" fill="none" stroke="rgba(247,240,225,.12)" stroke-width=".5" />
          <line x1="3" y1="50" x2="97" y2="50" stroke="rgba(247,240,225,.16)" stroke-width=".5" />
          <line x1="50" y1="3" x2="50" y2="97" stroke="rgba(247,240,225,.12)" stroke-width=".5" />
          {globe.land && <path d={globe.land} fill="rgba(247,240,225,.45)" />}
        </svg>
        {spot?.visible && (
          <div class="sent-dot" style={{ left: `${spot.x}%`, top: `${spot.y}%` }}>
            <i />
            <div class="sent-card">
              <div />
              <div />
            </div>
          </div>
        )}
      </div>

      <div class="sent-copy">
        <div class="sent-title">{t('sentTitle')}</div>
        <div class="sent-line">{t('sentLine', { country: countryName(country, s.lang), eta: eta(card, t) })}</div>
        <div class="sent-body">{t('sentBody', { who: card.to })}</div>
        <button class="sent-back" onClick={() => set({ sentCard: null, tab: 'mailbox' })}>
          <BackArrow size={26} />
          <span>{t('toMailbox')}</span>
        </button>
      </div>
    </div>
  );
}

/** How long this card will take, to the nearest day: it depends on the distance. */
function eta(card: Postcard, t: T): string {
  const days = Math.max(1, Math.round((Date.parse(card.deliverAt) - Date.parse(card.createdAt)) / 864e5));
  return days === 1 ? t('oneDay') : t('manyDays', { n: days });
}
